function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import '../../../scss/common/inputs.scss';
import { useStore } from '../../../store/storeUtils';
import { observer } from 'mobx-react';
import TextInput from './simpleComponents/TextInput';
const CMSTextInput = observer(props => {
  const store = useStore();
  let objectToUpdate = null;
  let valueFromConfig = null;
  if (props.field) {
    objectToUpdate = !props.baseObj ? store.previewConfiguration.configuration : props.baseObj;
    valueFromConfig = store.getFieldFromConfig(objectToUpdate, props.field);
  }
  const onTextChange = newValue => {
    if (props.field) {
      store.setFieldToConfig(objectToUpdate, props.field, newValue);
    }
    if (props.onTextChange) {
      props.onTextChange(newValue);
    }
  };
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    defaultValue: props.showMode ? props.defaultValue : valueFromConfig ? valueFromConfig : '',
    onTextChange: newVal => onTextChange(newVal)
  }));
});
export default CMSTextInput;